import { UseQueryResult } from 'react-query';

import { RewardAccount } from '@jebel/constants';

import { useCurrentUser } from 'shared/hooks';

import { useUserRewardAccount } from './useUserRewardAccount';

/**
 * React hook to fetch the current user's reward account for the selected community.
 *
 * Uses React Query to asynchronously retrieve reward account data from the tracking API.
 * The query is enabled only if there is an active session and a selected community.
 *
 * @returns {UseQueryResult<RewardAccount>} The query result containing the reward account data.
 * @throws {Error} If the current user or selected community is not available, or if the fetch fails.
 */
export function useCurrentUserRewardAccount(): UseQueryResult<RewardAccount> {
  const { user: currentUser } = useCurrentUser();

  return useUserRewardAccount(currentUser);
}
